import React from "react";
import styled from "styled-components/macro";
import { CircularProgress } from "@mui/material";

const Root = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: calc(100vh - 200px);
`;

function Loader () {
    return (
        <Root>
            <CircularProgress />
        </Root>
    );
}

export default Loader;
